const blogFontFace = {
  fontFace: `
    @font-face {
      font-family: charter;
      src: url(/fonts/charter/webfonts/charter_regular-webfont.eot);
      src: local('Charter'),
            url(/fonts/charter/webfonts/charter_regular-webfont.woff) format('woff'),
            url(/fonts/charter/webfonts/charter_regular-webfont.ttf) format('truetype');
      font-weight: normal;
      font-style: normal;
    }
    @font-face {
      font-family: charter;
      src: url(/fonts/charter/webfonts/charter_bold-webfont.eot);
      src: local('Charter'),
            url(/fonts/charter/webfonts/charter_bold-webfont.woff) format('woff'),
            url(/fonts/charter/webfonts/charter_bold-webfont.ttf) format('truetype');
      font-weight: bold;
      font-style: normal;
    }
    @font-face {
      font-family: charter;
      src: url(/fonts/charter/webfonts/charter_italic-webfont.eot);
      src: local('Charter'),
            url(/fonts/charter/webfonts/charter_italic-webfont.woff) format('woff'),
            url(/fonts/charter/webfonts/charter_italic-webfont.ttf) format('truetype');
      font-weight: normal;
      font-style: italic;
    }
    @font-face {
      font-family: charter;
      src: url(/fonts/charter/webfonts/charter_bold_italic-webfont.eot);
      src: local('Charter'),
          url(/fonts/charter/webfonts/charter_bold_italic-webfont.woff) format('woff'),
          url(/fonts/charter/webfonts/charter_bold_italic-webfont.ttf) format('truetype');
      font-weight: bold;
      font-style: italic;
    }
  `,
}

export default blogFontFace
